import React from 'react'

const FileIcon = () => (
    <svg width="104" height="128" viewBox="0 0 104 128" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M74.9429 3.31033H8.38832C5.62901 3.31033 3.31119 5.62758 3.31119 8.3862V119.614C3.31119 122.372 5.62901 124.69 8.38832 124.69H95.0307C97.79 124.69 100.108 122.372 100.108 119.614V28.5793L74.9429 3.31033V23.5034C74.9429 26.2621 77.2608 28.5793 80.0201 28.5793H100.218"
            fill="#F8FAFC"
        />
        <path
            d="M75.0533 97.6552H26.379C24.5027 97.6552 23.0678 96.2207 23.0678 94.3448C23.0678 92.469 24.5027 91.0345 26.379 91.0345H75.0533C76.9296 91.0345 78.3645 92.469 78.3645 94.3448C78.3645 96.2207 76.9296 97.6552 75.0533 97.6552ZM75.0533 77.4621H26.379C24.5027 77.4621 23.0678 76.0276 23.0678 74.1517C23.0678 72.2759 24.5027 70.8414 26.379 70.8414H75.0533C76.9296 70.8414 78.3645 72.2759 78.3645 74.1517C78.3645 76.0276 76.9296 77.4621 75.0533 77.4621ZM75.0533 57.1586H26.379C24.5027 57.1586 23.0678 55.7241 23.0678 53.8483C23.0678 51.9724 24.5027 50.5379 26.379 50.5379H75.0533C76.9296 50.5379 78.3645 51.9724 78.3645 53.8483C78.3645 55.7241 76.9296 57.1586 75.0533 57.1586Z"
            fill="#DAE1E7"
        />
        <path
            d="M102.536 26.2621L77.2608 0.993104C76.5985 0.441379 75.6052 0 74.6118 0H8.38831C3.75267 0 0 3.75172 0 8.38621V119.614C0 124.248 3.75267 128 8.38831 128H95.1411C99.7767 128 103.529 124.248 103.529 119.614V28.5793C103.529 27.6966 103.088 26.8138 102.536 26.2621ZM78.2541 11.2552L92.2714 25.269H80.0201C79.0267 25.269 78.2541 24.4966 78.2541 23.5034V11.2552ZM96.7967 119.614C96.7967 120.607 96.0241 121.379 95.0307 121.379H8.38831C7.39496 121.379 6.62235 120.607 6.62235 119.614V8.38621C6.62235 7.3931 7.39496 6.62069 8.38831 6.62069H71.5214V23.5034C71.5214 28.1379 75.2741 31.8897 79.9097 31.8897H96.7967V119.614Z"
            fill="#3D4852"
        />
    </svg>
)

export default FileIcon



// WEBPACK FOOTER //
// ./src/GetStarted/FileIcon.js